module.exports = __webpack_public_path__ + "static/media/error.afd590d1.svg";